import { ErrorCode, ConfirmCardPaymentErrorCause, ErrorName } from '../constants';

import { BaseError } from './BaseError';

export class ConfirmCardPaymentError extends BaseError {
  cause: ConfirmCardPaymentErrorCause;

  constructor({ message, cause }: { message: string; cause: ConfirmCardPaymentErrorCause }) {
    super(message, { code: ErrorCode.CONFIRM_CARD_PAYMENT, name: ErrorName.ConfirmCardPayment });
    this.cause = cause;
  }
}
